/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';

/**
 * The SystemControllerDtoMnSubLnbDetailResponse model module.
 * @module model/SystemControllerDtoMnSubLnbDetailResponse
 * @version 1.0
 */
class SystemControllerDtoMnSubLnbDetailResponse {
    /**
     * Constructs a new <code>SystemControllerDtoMnSubLnbDetailResponse</code>.
     * @alias module:model/SystemControllerDtoMnSubLnbDetailResponse
     */
    constructor() { 
        
        SystemControllerDtoMnSubLnbDetailResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SystemControllerDtoMnSubLnbDetailResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoMnSubLnbDetailResponse} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoMnSubLnbDetailResponse} The populated <code>SystemControllerDtoMnSubLnbDetailResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoMnSubLnbDetailResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('gnbNo')) {
                obj['gnbNo'] = ApiClient.convertToType(data['gnbNo'], 'Number');
            }
            if (data.hasOwnProperty('lnbNo')) {
                obj['lnbNo'] = ApiClient.convertToType(data['lnbNo'], 'Number');
            }
            if (data.hasOwnProperty('subNo')) {
                obj['subNo'] = ApiClient.convertToType(data['subNo'], 'Number');
            }
            if (data.hasOwnProperty('subName')) {
                obj['subName'] = ApiClient.convertToType(data['subName'], 'String');
            }
            if (data.hasOwnProperty('pageUrl')) {
                obj['pageUrl'] = ApiClient.convertToType(data['pageUrl'], 'String');
            }
            if (data.hasOwnProperty('sort')) {
                obj['sort'] = ApiClient.convertToType(data['sort'], 'Number');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
            if (data.hasOwnProperty('key')) {
                obj['key'] = ApiClient.convertToType(data['key'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoMnSubLnbDetailResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoMnSubLnbDetailResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['subName'] && !(typeof data['subName'] === 'string' || data['subName'] instanceof String)) {
            throw new Error("Expected the field `subName` to be a primitive type in the JSON string but got " + data['subName']);
        }
        // ensure the json data is a string
        if (data['pageUrl'] && !(typeof data['pageUrl'] === 'string' || data['pageUrl'] instanceof String)) {
            throw new Error("Expected the field `pageUrl` to be a primitive type in the JSON string but got " + data['pageUrl']);
        }
        // ensure the json data is a string
        if (data['key'] && !(typeof data['key'] === 'string' || data['key'] instanceof String)) {
            throw new Error("Expected the field `key` to be a primitive type in the JSON string but got " + data['key']);
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
SystemControllerDtoMnSubLnbDetailResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
SystemControllerDtoMnSubLnbDetailResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
SystemControllerDtoMnSubLnbDetailResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
SystemControllerDtoMnSubLnbDetailResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
SystemControllerDtoMnSubLnbDetailResponse.prototype['contentsReward'] = undefined;

/**
 * @member {Number} gnbNo
 */
SystemControllerDtoMnSubLnbDetailResponse.prototype['gnbNo'] = undefined;

/**
 * @member {Number} lnbNo
 */
SystemControllerDtoMnSubLnbDetailResponse.prototype['lnbNo'] = undefined;

/**
 * @member {Number} subNo
 */
SystemControllerDtoMnSubLnbDetailResponse.prototype['subNo'] = undefined;

/**
 * @member {String} subName
 */
SystemControllerDtoMnSubLnbDetailResponse.prototype['subName'] = undefined;

/**
 * @member {String} pageUrl
 */
SystemControllerDtoMnSubLnbDetailResponse.prototype['pageUrl'] = undefined;

/**
 * @member {Number} sort
 */
SystemControllerDtoMnSubLnbDetailResponse.prototype['sort'] = undefined;

/**
 * @member {Boolean} enabled
 */
SystemControllerDtoMnSubLnbDetailResponse.prototype['enabled'] = undefined;

/**
 * @member {String} key
 */
SystemControllerDtoMnSubLnbDetailResponse.prototype['key'] = undefined;






export default SystemControllerDtoMnSubLnbDetailResponse;

